module.exports = __webpack_public_path__ + "media/images/nexplay-03f433bdc8edee17bd98b46e62385550.png";